const STATUS = {
  NONE: 0,
  STARTED: 1,
  FINISHED: 2,
};

const ANSWER_TYPES = {
  EMPLOYEE: 0,
  MANAGER: 1,
  FINAL: 2,
};

export { STATUS, ANSWER_TYPES };



// WEBPACK FOOTER //
// ./src/containers/pmappraisals/appraisalEnums.js